import React from 'react';
import { PrivacyPolicy } from './SupportPage';

function PrivacyPage() {
  return (
    <div className="support-page">
      <PrivacyPolicy />
    </div>
  );
}

export default PrivacyPage;
